import { Component, Input, Output, EventEmitter, Type } from '@angular/core';
import { UserStateService } from 'src/app/auth/services/user-state.service';

export interface MenuAction {
  id: string;
  label: string;
  icon?: string;
  action?: () => void;
  requireRole?: string;
  disabled?: boolean;
}

export interface ActionsMenu {
  saveAction?: {
    id: string;
    label: string;
    action?: () => void;
    requireRole?: string;
    disabled: boolean | (() => boolean);
  };
  cancelAction?: {
    id: string;
    label: string;
    action: () => void;
  };
  deleteAction?: MenuAction;
  moreOptions?: MenuAction[];
}

@Component({
  selector: 'common-actions',
  templateUrl: './common-actions.component.html',
  styleUrls: ['./common-actions.component.scss'],
  standalone: false,
})
export class CommonActionsComponent {
  constructor(private userStateService: UserStateService) {}

  private _title: string;

  @Input()
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
    this.titleChange.emit(value);
  }
  @Output() titleChange = new EventEmitter<string>();
  @Input() titleAriaLabel: string;

  @Input() actions: ActionsMenu;
  @Input() saving = false;
  @Input() changeDate?: Date;
  @Input() changedBy?: string;
  @Input() customComponent?: Type<any>;
  @Input() componentInputs?: { [key: string]: any };

  hasVisibleMoreOptions(): boolean {
    const hasVisibleOption = this.actions?.moreOptions?.some(
      (action) =>
        !action.disabled &&
        this.userStateService.hasPermission(action.requireRole),
    );

    const hasVisibleDeleteAction =
      !!this.actions?.deleteAction &&
      !this.actions.deleteAction.disabled &&
      this.userStateService.hasPermission(
        this.actions.deleteAction.requireRole,
      );

    return hasVisibleOption || hasVisibleDeleteAction;
  }
}
